(() => {
  const initialized = new WeakSet();
  const wordCount = (text) => (text.trim().match(/\S+/gu) || []).length;

  function fitTitle(title) {
    if (!title.getClientRects().length) return;
    title.style.setProperty('--sb-title-fit', '1');
    const styles = getComputedStyle(title);
    const available = title.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
    const width = [...title.querySelectorAll('span')].reduce((sum, span) => sum + span.getBoundingClientRect().width, 0);
    const gap = parseFloat(styles.columnGap) || 0;
    if (width > 0) title.style.setProperty('--sb-title-fit', String(Math.max(0.1, (available - gap) / width)));
  }

  const observer = new ResizeObserver((entries) => entries.forEach(({ target }) => fitTitle(target)));
  function initialize(root = document) {
    root.querySelectorAll('.social-box-banner__title').forEach((title) => {
      if (initialized.has(title)) return;
      initialized.add(title);
      observer.observe(title);
      document.fonts.ready.then(() => fitTitle(title));
    });
  }

  function insertMiddle(root = document) {
    const template = root.querySelector('template[data-social-box-middle]');
    if (!template || root.querySelector('[data-social-box-placement="middle"]')) return;
    const threshold = Number(template.dataset.minimumWords) || 1200;
    const containers = [...root.querySelectorAll('.article-reading-layout .rte')];
    const content = containers.sort((a, b) => wordCount(b.textContent) - wordCount(a.textContent))[0];
    if (!content) return;
    const children = [...content.children];
    const total = wordCount(content.textContent);
    if (total < threshold) return;
    let preceding = 0;
    const candidates = [];
    children.forEach((child) => {
      // Insert only before a top-level section heading, never inside lists/tables/paragraphs.
      if (child.tagName === 'H2' && preceding >= 400 && total - preceding >= 400) {
        candidates.push({ heading: child, distance: Math.abs(total / 2 - preceding) });
      }
      preceding += wordCount(child.textContent);
    });
    candidates.sort((a, b) => a.distance - b.distance);
    if (!candidates.length) return;
    candidates[0].heading.before(template.content.cloneNode(true));
    initialize(content);
  }

  function start(root = document) { insertMiddle(root); initialize(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.social-box-banner__title').forEach((title) => observer.unobserve(title));
  });
})();
